import Layout from '../Components/Layout/Layout';

const Explanation = () => {
    return (
        <Layout>
            <div className="max-w-4xl mx-auto px-4 py-0 md:py-8">
                <h1 className="text-2xl font-bold text-ps-blue-dark mb-8">DEEL EENVOUDIG ALLERGENENINFORMATIE MET JE GASTEN</h1>
                <div className="prose prose-sm max-w-none">
                    <div className="bg-white p-0 space-y-2"> 
                        <section>
                            <h2 className="text-xl font-semibold text-ps-blue-dark mb-4">Maak online een allergenenkaart met de PS Menu Maker</h2>
                            <div className="space-y-4 text-gray-600">
                                Als foodprofessional wil je graag duidelijk communiceren over allergenen. Telkens je menukaart updaten kost tijd en is foutgevoelig. De oplossing? Maak een online kaart met de PS Menu Maker. Handig voor gasten én personeel.
                            </div>
                        </section>

                        <section>
                        <br />
                            <h2 className="text-xl font-semibold text-ps-blue-dark mb-4">Maak gratis je online menukaart met allergie-informatie</h2>
                            <ul className="list-disc pl-5 space-y-2 text-gray-600">
                                <li>Maak een account aan voor jouw bedrijf en jezelf in de PS Menu Maker</li>
                                <li>Maak verschillende categorieën aan die op jouw menukaart staan weergegeven</li>
                                <li>Voeg gerechten toe aan de verschillende categorieën en publiceer deze</li>
                                <li>Bouw je gerechten op door producten te scannen</li>
                                <li>Genereer jouw unieke QR-code vanuit de app en deel deze met je gasten</li>
                            </ul>
                        </section>

                        <section>
                        <br />
                            <h2 className="text-xl font-semibold text-ps-blue-dark mb-4">Voordelen van jouw digitale allergenenkaart</h2>
                            <ul className="list-disc pl-5 space-y-2 text-gray-600">
                                <li>Je voldoet aan de allergenenwetgeving</li>
                                <li>Altijd up-to-date allergeneninformatie voor personeel én gast</li>
                                <li>De PS Menu Maker leidt tot verbetering van service en gastbeleving</li>
                                <li>Minder foutgevoelig dan mondelinge informatie</li>
                                <li>Vragen over allergenen komen niet meer bij keukenpersoneel terecht</li>
                                <li>Je menukaart is in alle talen beschikbaar</li>
                                <li>Wijzigingen pas je maar op één plek aan</li>
                                <li>Het scheelt dus tijd, extra handelingen én uitleg</li>

                            </ul>

                        </section>

                        <section>
                        <br />
                            <h2 className="text-xl font-semibold text-ps-blue-dark mb-4">Geschikt voor alle foodprofessionals</h2>
                            <div className="space-y-4 text-gray-600">
                                <p>De menukaartmaker van PS is geschikt voor iedereen die in de horeca werkt. Met de PS Menu Maker help je gasten met allergieën, intoleranties, dieetwensen, speciale verzoeken en andere vragen over producten en ingrediënten. Proactief en gastvrij!</p>
                                <p>Samen met jou willen we de PS Menu Maker blijven verbeteren!
                                Daarom is er in deze beta-versie van de app een mogelijkheid om jouw feedback achter te laten.
                                    Ga aan de slag met de PS Menu Maker, en laat weten weten wat je ervan vindt door op de feedback button te klikken!</p>
                                <p>Aan de slag met jouw digitale allergenenkaart
                                Download de gratis PS Menu Maker app direct en zorg voor
                                    up-to-date productinformatie voor personeel én gast.
                                </p>
                            </div>

                        </section>


                        <p className="text-gray-600 footer-relaxed pt-8 text-xs">
                            PS in foodservice is dé centrale plek voor productinformatie van voeding, drank en non-food. PS borgt en deelt informatie van producenten, groothandels en afnemers zoals cateraars, zorginstanties, horeca en detailhandel. Benieuwd wat PS in foodservice nog meer voor jou kan betekenen? Bekijk onze diensten. Ontdek ook het gratis FoodBook met meer dan 250.000 producten en hun productinformatie
                        </p>

                    </div>
                </div>
            </div>
             
        </Layout>
    );
};

export default Explanation;